"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Uninvested = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var investment_1 = require("../../model/investment");
var service_1 = require("../../../library/base/service");
var Uninvested = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Uninvested, _super);
    function Uninvested() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '未投资客户初始化接口';
        _this.code = '101012';
        _this.desc = '未投资客户初始化接口';
        _this.requestParams = new investment_1.UninvestedRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Uninvested;
}(service_1.BaseService));
exports.Uninvested = Uninvested;
//# sourceMappingURL=uninvested.js.map